import { HTMLAttributeAnchorTarget } from 'react';

import { Button, ButtonProps } from '@mui/material';
import { PathParams, QueryParams, useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { Link } from 'react-router-dom';

export type LinkButtonProps = ButtonProps & {
  pathParams: PathParams;
  queryParams?: QueryParams;
  label?: string;
  target?: HTMLAttributeAnchorTarget | undefined;
};

export const LinkButton = ({ pathParams, queryParams, label, ...restProps }: LinkButtonProps) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const to = createPathWithQuery(pathParams, queryParams);

  return (
    <Button component={Link} to={to} {...restProps}>
      {label}
    </Button>
  );
};
